import { useRevealClass } from '../../../hooks/useRevealClass'
import { useToast } from '../../../context/ToastContext'
import FeaturedProductsSlider from './FeaturedProductsSlider'
import './FeaturedProductsSection.css'

export default function FeaturedProductsSection() {
  const { showToast } = useToast()
  const headerReveal = useRevealClass()

  return (
    <section id="featured-products" className="relative overflow-hidden" style={{ background: '#FEFCF8' }}>
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '1px', background: 'linear-gradient(90deg,transparent,rgba(200,146,42,.28),transparent)' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '1px', background: 'linear-gradient(90deg,transparent,rgba(200,146,42,.2),transparent)' }} />
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle,rgba(200,146,42,.03) 1px,transparent 1px)', backgroundSize: '36px 36px' }} />
        <div style={{ position: 'absolute', top: '50%', right: '-6%', transform: 'translateY(-50%)', width: '40vw', height: '40vw', background: 'radial-gradient(ellipse,rgba(200,146,42,.055) 0%,transparent 65%)', borderRadius: '50%' }} />
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12" style={{ paddingTop: '72px', paddingBottom: '80px' }}>
        <div ref={headerReveal.ref} className={`ps-reveal flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10${headerReveal.visible ? ' ps-visible' : ''}`}>
          <div>
            <div className="flex items-center gap-4 mb-4">
              <div style={{ height: '1px', width: '40px', background: 'linear-gradient(90deg,transparent,rgba(200,146,42,.5))' }} />
              <span style={{ fontSize: '9px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.3em', color: 'rgba(200,146,42,.72)' }}>
                Featured Products
              </span>
            </div>
            <h2 className="font-royal font-normal" style={{ fontSize: 'clamp(26px,3.4vw,46px)', lineHeight: 1.08, color: '#1C0A03' }}>
              GENUINE GEMSTONES
              <br />
              <span style={{ background: 'linear-gradient(135deg,#C8922A 0%,#E5A820 45%,#C8922A 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                &amp; SACRED REMEDIES
              </span>
            </h2>
            <p className="font-body" style={{ fontSize: '13px', lineHeight: 1.7, color: '#7A5C38', maxWidth: '480px', marginTop: '10px' }}>
              Lab-certified gemstones, Rudraksha, Yantras and puja items — all energised and blessed by Maharaj Ji.
            </p>
          </div>
          <button type="button" className="ps-cta-main" onClick={() => showToast('Opening the Divine Shop…')}>
            Visit Divine Shop
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
          </button>
        </div>

        <FeaturedProductsSlider />
      </div>
    </section>
  )
}
